import React from "react";
import Loader from "../components/loader";
import { useLoaderData, useLocation } from "react-router-dom";
import { searchLoader } from "../hooks/useInventory";
import { Tile } from "../components/views";
import URI from "urijs";

const Search = () => {
  const { data, loading } = useLoaderData();
  const location = useLocation();
  const { term } = new URI(location.pathname + location.search).search(true);

  if (loading || !data?.search?.items) return <Loader />;

  return (
    <div id="searchResults">
      <div className="header">
        <h1>Search results: {term}</h1>
      </div>
      <div className="content">
        <div className="entries">
          {data.search.items.length === 0 ? <p>No results...</p> : null}
          {data.search.items.map(e => (<Tile key={e.id} item={e} />))}
        </div>
      </div>
    </div>
  );
};

const DataLoader = async props => {
  const { term } = new URI(props.request.url).search(true);
  return searchLoader((term || "").toLowerCase().trim());
};

const Routes = [{
  path: "/search",
  element: <Search />,
  loader: DataLoader
}];

export default Search;
export { Routes };
